import React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import styleFile from './AvailRoomDetail.js';
import RichText from '@synergycms_core/components/generic/RichText';
import Image from '@synergycms_core/components/generic/Image';
import AmenitiesList from '../../AmenitiesList';
import AvailDatepickerModal from '../../AvailDatepicker/AvailDatepickerModal.jsx';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider'
import AvailRoomDetailModal from './AvailRoomDetailModal.jsx';
import ModalMedia from '../../ModalMedia/ModalMedia.jsx';
import { CSSTransition } from 'react-transition-group';
import { List } from 'immutable';
import { cleanHotelPreferences } from '../../../../utils';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import AvailDatepicker from '../../AvailDatepicker/AvailDatepicker.jsx';
import NewAvailButton from '../../AvailDatepicker/NewAvailButton.jsx';
import Button from '@synergycms_core/components/generic/Button';
import actions from '../../../../store/actions';
import moment from 'moment';
import { showPopover } from '@synergycms_core/components/providers/popoverProvider.jsx';
import { isUsDomain, isUkDomain } from 'synergycms_core/src/utils/utils.js';

const ShowMoreDetails = () => (
  <RichText
    text={'_%ver más detalles%_'}
    ucFirst={true}
    innerStyle={['roboto14Gold', 'roomCharacteristic']}
    translate={true}
  />
);

const NoAvailRoomDetail = class NoAvailRoomDetail extends React.Component {
  static displayName = 'NoAvailRoomDetail';

  constructor(props) {
    super(props);
    this.state = {
      showDatepickerAvail: false,
      showCalendar: false,
      width:null
    };
    this.widthRef = React.createRef();
  }

  toogleDatepickerModal = e => {
    e.preventDefault();
    this.setState(state => ({
      showCalendar: !state.showCalendar
    }));
  };

  toggleDatepicker = e => {
    e.preventDefault();
    this.props.config.newRange(moment(), moment().add(1, "month").endOf("month"))
    this.setState(state => ({
      showDatepickerAvail: !state.showDatepickerAvail
    }));
  };

  onRangeChange = (dates) => {
    this.setState(state => ({
      dates: dates
    }));
  };

  closeModal = () => {
    this.setState(state => ({
      showCalendar: false
    }));
    // cerrar modal global si existe
    const toggle = this.props.toggleModal || (this.props.config && this.props.config.toggleModal);
    if (typeof toggle === "function") {
      toggle(false, "roomDetailTooltip");
    }

    // cerrar estado local
    this.setState({
      showCalendar: false,
      showDatepickerAvail: false
    });

    // desbloquear scroll
    try {
      if (document?.body?.style) {
        document.body.style.overflow = "";
      }
    } catch (err) {}
  };
  
  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  getWidthComponent = () => {
    if(this.widthRef.current){
      this.setState({ 
        width: this.props.theme.getDesirableWidth(this.widthRef.current.offsetWidth, this.widthRef.current.offsetHeight)
      });
    }
  }

  componentDidMount() {
    this.getWidthComponent();
  }

  render() {
    const { config, theme } = this.props,
      {
        room,
        currentHotel,
        staticRooms,
        adults,
        childs,
        checkin,
        checkout,
        langCode,

      } = config;

    const { classes } = theme.styles;
    const resizableImages = theme.resizableImages && this.state.width ? this.state.width : '';
    // El nom de les habitacions s'ha d'agafar de les seccions d'habitació, no de l'habitació com a tal
    let roomSection = room;
    let roomName = roomSection.get('name');

    if (roomSection && roomSection.get('video_url')) {
      roomSection = roomSection.set('default_video', roomSection.get('video_url'));
    }
    if (roomSection && roomSection.get('tour_360_url')) {
      roomSection = roomSection.set('wide_view_url', roomSection.get('tour_360_url'));
    }

    const totalGuests = adults + (childs > 0 ? childs : 0);

    const surfaceM2 = parseInt(roomSection.get('m2'), 10);
    // convertir de m2 a ft2 (para dominio .us/.co.uk)
    const surfaceFt2 = Math.round(surfaceM2 * 10.7639);

    const dateFormat = 'dd, D MMM';

    let maxOccupRoom = staticRooms
      .maxBy(r => (r.get('id') === room.get("id") ? r.get('standard_occupancy') : 0))
      .get('standard_occupancy');

    if (maxOccupRoom < totalGuests) {
      maxOccupRoom = totalGuests;
    }

    return (
      <div
        className={[
          theme.computedInnerStyle
        ].join(' ')}>
        <div className={classes.header}>
          <div className={[classes.positionImage].join(' ')} ref={this.widthRef}>
            <Image
              innerStyle={'backgroundImageBase'}
              backgroundImage={
                process.env.NODE_ENV === 'development'
                  ? 'https://edge.media.datahc.com/HI378221428.jpg' + resizableImages
                  : roomSection.get('photo') + resizableImages
              }
              alt={roomName}
            />
            <ModalMedia mediaEntity={roomSection} innerStyle={classes.buttonImage} langCode={langCode} icon={{ unicodeContent:roomSection.get('photos').size > 1 ? 'e043' : null }} />
          </div>
          <div className={classes.heading} tabIndex={-1}>
            <AvailRoomDetailModal
              roomInfo={roomSection}
              roomName={roomName}
              hotelInfo={currentHotel}
              buttonContent={() => <RichText innerStyle={['avail', 'roomTitle']} text={roomName} />}
            />
            <span className={classes.roomDetails}>
              <RichText innerStyle={surfaceM2 > 0 ? ['roboto13Gray', 'roomSize', 'borderRightSoft'] : ['hideEdit']}>
                {isUsDomain() || isUkDomain() ? (
                  <>
                    {surfaceFt2}ft<sup>2</sup>
                  </>
                ) : (
                  <>
                    {surfaceM2}m<sup>2</sup>
                  </>
                )}
              </RichText>
              <div className={classes.maxOcupation}>
                <RichText text={'_%ocupación máx.%_'} innerStyle={['roboto14Gray']} ucFirst={true} translate={true} />
                <RichText text={': ' + maxOccupRoom} innerStyle={['roboto14Gray', 'maxOcup']} />
              </div>
              <div className={classes.maxOcupation}>
                <AvailRoomDetailModal
                  roomInfo={roomSection}
                  roomName={roomName}
                  hotelInfo={currentHotel}
                  buttonContent={ShowMoreDetails}
                />
              </div>
            </span>
            <div className={[classes.rowHotelContent, classes.amenitiesContainer].join(' ')}>
              <AmenitiesList
                maxAmenities={4}
                list={roomSection.get('highlighted_amenities', List())}
                innerStyle={['roomAmenities']}
              />
            </div>
          </div>
          <div className={classes.noDispoCalendar}>
            {!this.state.showDatepickerAvail && (
              <div className={classes.noDispoCalendarInfo}>
                <div className={classes.noDispoCalendarTextCell}>
                  <div className={classes.noDispoCalendarTextCellContent}>
                    <Image unicodeContent="e143" innerStyle={['gold',classes.noAvailInfoIcon]} />
                    <RichText text={moment(checkin).format(dateFormat)} innerStyle={classes.noAvailInfoTextBold} ucFirst={true} />
                    {' - '}
                    <RichText text={moment(checkout).format(dateFormat)} innerStyle={classes.noAvailInfoTextBold} ucFirst={true} />{' '}
                    <RichText text={'_%fechas no disponibles%_'} translate={true} innerStyle={classes.noAvailInfoText} />
                  </div>
                </div>
                <div className={classes.noDispoCalendarCell}>
                  {this.isMobile() ?
                    <>
                      <AvailDatepickerModal
                        modalTitle={'_%calendario de precios%_'}
                        modalText={'_%Ver Disponiblidad%_'}
                        onRangeChange={this.onRangeChange}
                        dates={this.state.dates}
                        room={room}
                        innerStyle={classes.noAvailRoomDetailModal}
                        buttonEvent={this.toogleDatepickerModal}
                        closeCallback={this.closeModal}
                      />
                      { this.state.showCalendar && <NewAvailButton innerStyle={['availDatepickerDateButton']} dates={this.state.dates} onSameDateSelected={this.closeModal} />}
                    </> :
                    <Button onClick={this.toggleDatepicker} innerStyle={['toggleMainButtonReverse']} ariaLabel={'_%Ver Disponiblidad%_'} translate={true}>
                      <RichText text={'_%Ver Disponiblidad%_'} translate={true} ucFirst={true} />
                    </Button>
                  }
                </div>
              </div>
            )}
            {!this.isMobile() &&
              <CSSTransition
                in={this.state.showDatepickerAvail}
                timeout={700}
                mountOnEnter
                unmountOnExit
                classNames={{
                  enter: classes.roomPreferenceEnter,
                  enterActive: classes.roomPreferenceEnterActive,
                  exit: classes.roomPreferenceLeave,
                  exitActive: classes.roomPreferenceLeaveActive
                }}>
                <div className={classes.datepickerContainer}>
                  <Button
                    onClick={this.toggleDatepicker}
                    innerStyle={['closeButton', classes.datepickerCloseButton].join(' ')}
                    icon={{ unicodeContent: 'e001' }}
                    defaultStyle={false}
                    ariaLabel={'_%cerrar%_'}
                    translate={true}
                  />
                  <AvailDatepicker
                    roomId={room.get("id")}
                    key={room.get("id")}
                    onRangeChange={this.onRangeChange}
                    innerStyle={['availDatepickerModal', classes.dispoPickerAvail].join(' ')}
                  />
                  <NewAvailButton dates={this.state.dates} room={room} onSameDateSelected={this.toggleDatepicker} />
                </div>
              </CSSTransition>
            }
          </div>
        </div>

      </div>
    );
  }
};



const mapDispatchToProps = (dispatch, ownProps, state) => {
  return {
    newRange: (date) => ({ currentFirstMonth, months }) => {
      if (currentFirstMonth >= moment().startOf("day")) {
        const current = moment();
        const start = current > currentFirstMonth ? current : moment(currentFirstMonth).startOf("month");
        const end = moment(start).add(months - 1, "month").endOf("month");
        dispatch(actions.availCalendar.getAsync(start, end));
      }
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const queryParams = store.getIn(['hotels', hotelId, 'params', 'params']);

  return {
    staticRooms: store.getIn(['hotels', hotelId, 'rooms']),
    currentHotel: store.getIn(['hotels', hotelId]),
    hotelPreferences: cleanHotelPreferences(store.getIn(['hotels', hotelId, 'preferences'], List())),
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    checkin: queryParams.get('date'),
    checkout: moment(queryParams.get('date'))
      .add(queryParams.get('stay_length'), 'days')
      .format('YYYY-MM-DD')
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    newRange: dispatchProps.newRange(stateProps.date),
  });
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  PropertyManager([
    'room',
    'currentHotel',
    'onCalendarChange',
    'newRange',
    'staticRooms',
    'adults',
    'childs',
    'checkin',
    'checkout',
    'langCode',
  ]),
  showPopover,
  withThemeJSS({ styleFile, link: true, index: 200 }),
  withContent('i18n')
)(NoAvailRoomDetail);
